import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  ModalFooter,
  Checkbox,
  SimpleGrid,
  Spacer,
  Switch,
  FormControl,
  FormLabel,
  background,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import epl from "../eplstyles";
import edp from "../clientstyles/edpstyles"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
// import { Tooltip } from "@chakra-ui/react";

const Styling = (props) => {
  const [stylesList, setStyleList] = useState([]);
  const [tooltip, setTooltip] = useState({ id: "" });
  const [client, setClient] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  // const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    switch (props?.currentClient) {
      case "epl":
        setClient(epl)
        break;
      case "edp":
        setClient(edp)
        break;
      default:
        setClient(epl)
        break;
    }
  }, [props.currentClient])


  const updateSelectedStyles = function (checked, data) {
    if (checked) {
      setStyleList([...stylesList, data]);
    } else {
      let filtered = stylesList.filter(function (el) {
        return el !== data;
      });
      setStyleList(filtered);
    }
  };
  const navigate = useNavigate()
  const checkAll = (checked) => {
    if (checked) {
      setStyleList([])
      Object.keys(epl).map((i) => {
        return setStyleList((prev) => [...prev, i]);
      });
    } else {
      setStyleList([]);
    }
  };

  const handleClick = () => {
    props.editToolAction({})

    setTimeout(() => {
      if (!isChecked) {
        props.eplStyles(stylesList);
        setStyleList([]);
        props.toolStyles({ key: null, data: null, isChecked });
      }
      else {
        props.toolStyles({ key: props?.currentClient, data: stylesList, isChecked });
        setStyleList([]);
        props.editToolRejected()
        navigate("#suggestions")
      }
    }, 0)
  };


  useEffect(() => {
    if (props.isChecked) {
      setIsChecked(true)
      setStyleList(props.editToolStyles[props?.currentClient] || [])
    }
    else {
      setIsChecked(false)
    }
  }, [props.isOpen])



  return (
    <Modal size={"xl"} onClose={props.onClose} isOpen={props.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {props.currentClient}
          <Spacer />
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <Checkbox
              isChecked={stylesList.length === Object.keys(epl).length}
              onChange={(e) => {
                checkAll(e.target.checked);
              }}
              style={{ marginTop: "10px" }}
            >
              Select All
            </Checkbox>
            <FormControl style={{ width: "fit-content" }} display="flex" alignItems="center" justifyContent="end">
              <FormLabel style={{ fontSize: "15px", cursor: "pointer" }} htmlFor="interactive" mb="0">
                Interactive mode
              </FormLabel>
              <Switch
                id="interactive"
                isChecked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                colorScheme="blue"
                size="sm"
              />
            </FormControl>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {
            client !== null &&
            <SimpleGrid columns={2} spacing={4}>
              {Object.keys(client).map((i) => (
                <div key={i}>
                  <Checkbox
                    className="checkbox"
                    isChecked={stylesList.includes(i)}
                    onChange={(e) => updateSelectedStyles(e.target.checked, i)}
                    key={epl[i]?.name}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        gap: "4px",
                        display: "flex",
                        alignItems: "center",
                        width: "230px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>{client[i]?.name}</div>
                      <div
                        className="infoicon"
                        onMouseEnter={() => setTooltip({ id: i })}
                        onMouseLeave={() => setTooltip({ id: "" })}
                      >
                        <InfoOutlineIcon />
                      </div>
                      {tooltip.id === i ? (
                        <div
                          style={{
                            position: "absolute",
                            height: "auto",
                            width: "200px",
                            background: "rgba(14,13 , 13, 0.64)",
                            // background: "#faf9f9",
                            backdropFilter: "blur(4px)",
                            right: "-180px",
                            top: "25px",
                            zIndex: "1000",
                            color: "#fff",
                            borderRadius: "5px",
                            padding: "10px",
                          }}
                        >
                          {client[i]?.description}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Checkbox>
                </div>
              ))}
            </SimpleGrid>
          }

        </ModalBody>
        <ModalFooter>
          <Button
            style={{}}
            onClick={() => {
              if (stylesList.length > 0) {
                handleClick(props);
                props.onClose();
              }
            }}
            mx={2}
            bg="var(--btn-bg)"
            color="var(--btn-text)"
            _hover={{ bg: "var(--btn-hover)" }}
          >
            Submit
          </Button>
          <Button onClick={props.onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
const mapStateToProps = (state, ownProps) => ({
  editToolStyles: state.toolStyles.function,
  isChecked: state.toolStyles.isChecked,
})
const mapDispatchToProps = (dispatch) => {
  return {
    eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    // submitAction: (res) => dispatch({ type: "onChange", payload: res }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Styling);
